export default __webpack_public_path__ + "static/media/girl.74c11336.jpg";